/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const EstonianFlagIconSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" id="flag-icons-ee" viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <rect width="640" height="477.9" fill="#000001" rx="0" ry="0"/>
      <rect width="640" height="159.3" y="320.7" fill="#fff" rx="0" ry="0"/>
      <path fill="#1791ff" d="M0 0h640v159.3H0z"/>
    </g>
  </svg>
);

export const EstonianFlagIcon = (props) => (
  <Icon component={EstonianFlagIconSvg} {...props} />
);
